<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'sbRateDetail',
    components: {
      baseEdit,
    },
  };
</script>
